module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/logo-isi-eddfa19fa4bc21c11d3b4c7b7a30dc30.svg";